import { Group, Stack, Space, Checkbox } from "@mantine/core";
import { Text } from "@/components/ui/Text";

import { IconArrowRight } from "@tabler/icons-react";
import { Link } from "../ui/Link";

export const PDFRecsCheckbox = ({
  isSmall = false,
  isCompleted = false,
  isExportView = false,
}: {
  isSmall?: boolean;
  isCompleted?: boolean;
  isExportView?: boolean;
}) => {
  return (
    <Stack gap={4} w="100%" flex={1}>
      <Group flex={1} gap={0} align="center" w="100%">
        <Checkbox
          color="primary"
          size={isSmall ? "xs" : "md"}
          readOnly
          checked={isCompleted}
        />
        <Space w="md" />
        <Stack flex={1} gap={0}>
          <Group
            gap={0}
            pl={isSmall ? 4 : 8}
            flex={1}
            justify="flex-start"
            w="100%"
          >
            <Text titleStyle={isSmall ? "h6" : "h5"} fw={500}>
              Upload your CareerLeader report to get personalized
              recommendations
            </Text>
            {isSmall ? null : (
              <>
                <Space w="md" />
              </>
            )}
          </Group>
        </Stack>
      </Group>

      {isSmall ? null : (
        <Group
          flex={1}
          justify="space-between"
          wrap="nowrap"
          pl={isSmall ? "xl" : 48}
          pt={isExportView ? 8 : undefined}
          w="100%"
        >
          <Link
            to="/recs/careerleader"
            target="_blank"
            style={{ fontSize: 13 }}
          >
            <Group gap={4}>
              Click here to upload your CareerLeader report{" "}
              <IconArrowRight size={16} />
            </Group>
          </Link>
        </Group>
      )}
    </Stack>
  );
};
